import {
  IFrontExportParams,
  IMobPlatformProvider,
  IBackendExportParams,
} from '@ibiz-template/runtime';
import { UrlHelper, getToken } from '@ibiz-template/core';
import { VueBrowserPlatformProvider } from './vue-browser-platform-provider';
import { DownloadType } from '.';

const ua = window.navigator.userAgent.toLowerCase();

/**
 * @description 安卓搭载平台适配器
 * @export
 * @class AndroidPlatformProvider
 */
export class AndroidPlatformProvider
  extends VueBrowserPlatformProvider
  implements IMobPlatformProvider
{
  /**
   * 是否为安卓内置WebView环境
   */
  private isAndroidWebView =
    /Android|Adr/i.test(ua) && /wv/i.test(ua) && /version\/4\.0/i.test(ua);

  /**
   * @description 下载
   * @param {string} url 下载路径
   * @param {string} fileName 文件名称
   * @returns {*}  {Promise<boolean>}
   * @memberof AndroidPlatformProvider
   */
  async download(url: string, fileName: string): Promise<boolean> {
    if (this.isAndroidWebView) {
      const search = new URLSearchParams({
        type: DownloadType.DOWNLOAD,
        token: getToken() || '',
        data: JSON.stringify({ url, fileName }),
      });
      window.open(`${UrlHelper.routeBase}/download?${search}`, '_self');
      return Promise.resolve(true);
    }
    return super.download(url, fileName);
  }

  /**
   * @description 后台导出
   * @param {IBackendExportParams} args
   * @returns {*}  {Promise<boolean>}
   * @memberof AndroidPlatformProvider
   */
  async backendExport(args: IBackendExportParams): Promise<boolean> {
    if (this.isAndroidWebView) {
      const search = new URLSearchParams({
        type: DownloadType.BACKEND_EXPORT,
        token: getToken() || '',
        data: JSON.stringify(args),
      });
      window.open(`${UrlHelper.routeBase}/download?${search}`, '_self');
      return Promise.resolve(true);
    }
    return super.backendExport(args);
  }

  /**
   * @description 前台导出
   * @param {IFrontExportParams} args
   * @returns {*}  {Promise<boolean>}
   * @memberof AndroidPlatformProvider
   */
  async frontExport(args: IFrontExportParams): Promise<boolean> {
    if (this.isAndroidWebView) {
      const search = new URLSearchParams({
        type: DownloadType.FRONT_EXPORT,
        token: getToken() || '',
        data: JSON.stringify(args),
      });
      window.open(`${UrlHelper.routeBase}/download?${search}`, '_self');
      return Promise.resolve(true);
    }
    return super.frontExport(args);
  }

  /**
   * @description 打开浏览器
   * @param {string} _url 路径
   * @returns {*}  {Promise<void>}
   * @memberof AndroidPlatformProvider
   */
  async openBrowser(_url: string): Promise<void> {}

  getShowViewHeader(): boolean {
    return ibiz.config.view.mobShowViewHeader;
  }

  getShowPresetBack(): boolean {
    return ibiz.config.view.mobShowPresetBack;
  }
}
